/** Kleur voor selectie: vaste 6 opties (niet uit DB). */
export interface SelectionMarkColor {
  name: string;
  value: string;
  /** Of deze kleur gebruikt wordt in deze selectie (aan/uit). */
  used?: boolean;
  min_birth_date?: string | null;
  max_birth_date?: string | null;
}

/** Hex voor UI (rondjes, indicator). */
const MARK_COLOR_HEX: Record<string, string> = {
  roze: '#ec407a',
  oranje: '#e67e22',
  geel: '#f1c40f',
  groen: '#27ae60',
  blauw: '#2980b9',
  rood: '#c0392b'
};

export function getSelectionMarkColorHex(value: string): string {
  return MARK_COLOR_HEX[value] ?? 'transparent';
}

/** Vaste zes kleuren voor in de UI (color picker / dropdown). */
export const SELECTION_MARK_COLORS: SelectionMarkColor[] = [
  { name: 'Roze', value: 'roze' },
  { name: 'Oranje', value: 'oranje' },
  { name: 'Geel', value: 'geel' },
  { name: 'Groen', value: 'groen' },
  { name: 'Blauw', value: 'blauw' },
  { name: 'Rood', value: 'rood' }
];
